<template>
    <div>
        <div class="d-flex-center py-5">
            <img src="@/assets/report/monthly.png">
        </div>
        <v-container>
            <v-row>
                <v-col
                    class="d-flex-center pb-0"
                    offset="4"
                    cols="4">

                    <v-autocomplete
                        v-model="employees"
                        :items="employeeOptions"
                        chips multiple>
                        <template v-slot:selection="data">
                            <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="removeEmployee(data.item)">
                                {{ data.item.text }}
                            </v-chip>
                        </template>
                        <template v-slot:prepend-item>
                            <v-list-item
                                @mousedown.prevent
                                @click="onSelectAll">
                                <v-list-item-content>
                                    <div class="emp-item">
                                        <v-checkbox
                                            :input-value="employees.length > 0"
                                            :on-icon="selectAllIcon"
                                            color="#d76436"
                                            readonly dense hide-details
                                        ></v-checkbox>
                                        <v-list-item-title>
                                            {{ $vuetify.lang.t('$vuetify.monthly.selectAll') }}
                                        </v-list-item-title>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <div class="emp-item">
                                    <v-checkbox
                                        :input-value="data.attrs.inputValue"
                                        :on-icon="'mdi-checkbox-marked'"
                                        color="#d76436"
                                        readonly dense hide-details
                                    ></v-checkbox>
                                    <v-list-item-title
                                        class="text-black"
                                        v-html="data.item.text">
                                    </v-list-item-title>
                                </div>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    class="d-flex-center pb-0"
                    offset="4"
                    cols="4">
                    <v-menu
                        v-model="monthPickerShow"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">

                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="monthFormatted"
                                :label="$vuetify.lang.t('$vuetify.monthly.monthly')"
                                prepend-inner-icon="event"
                                @click:prepend-inner="monthPickerShow = true"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            type="month"
                            v-model="monthPick"
                            @input="monthPickerShow = false"
                            :max="maxMonth"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                    class="d-flex-space-around pt-0"
                    offset="4"
                    cols="4">
                    <v-btn
                        color="red lighten-2"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit(typePdf)">
                        {{ $vuetify.lang.t('$vuetify.monthly.exportPDF') }}
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit(typeExcel)">
                        {{ $vuetify.lang.t('$vuetify.monthly.exportExcel') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'EmployeeMonthlyLog',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            monthPickerShow: false,
            monthPick: new Date().toISOString().substr(0, 7),
            maxMonth: new Date().toISOString().substr(0, 7),
            monthFormatted: this.monthFormat(new Date().toISOString().substr(0, 7)),
            employees: [],
            employeeOptions: [],
            typePdf: 'pdf',
            typeExcel: 'excel',
            exportPath: ''
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        selectAllIcon () {
            if (this.employees.length === 0) {
                return null
            } else if (this.employees.length !== this.employeeOptions.length) {
                return 'mdi-minus-box'
            } else {
                return 'mdi-checkbox-marked'
            }
        }
    },

    methods: {
        monthFormat (monthly) {
            const [year, month] = monthly.split('-')
            const BEYear = parseInt(year) + 543
            return `${month}/${BEYear}`
        },

        async getEmployees (branchId = null) {
            const response = await this.axios.get(`employee/options?branch=${branchId || this.branchId}`)
            if (response && response.data && response.data.status === 'ok') {
                this.employeeOptions = response.data.data
            }
        },

        async submit (reportType) {
            if (this.typePdf === reportType) {
                this.exportPath = 'report/employee-monthly-log/pdf'
                await this.genPdfMonthlyReport()
            } else if (this.typeExcel === reportType) {
                this.exportPath = 'report/employee-monthly-log/excel'
                await this.genExcelReport()
            }
        },

        async genPdfMonthlyReport () {
            this.$store.dispatch('setLoading', true)
            const [year, month] = this.monthPick.split('-')
            const body = { year: parseInt(year), month: parseInt(month), employees: this.employees }
            const response = await this.axios.post(this.exportPath, body, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadPdfFile(response.data)
                this.$store.dispatch('setLoading', false)
            }
        },

        async genExcelReport () {
            this.$store.dispatch('setLoading', true)
            const [year, month] = this.monthPick.split('-')
            const body = { year: parseInt(year), month: parseInt(month), employees: this.employees }
            const response = await this.axios.post(this.exportPath, body, {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadExcelFile(response.data, `report-${this.monthPick}.xls`)
                this.$store.dispatch('setLoading', false)
            }
        },

        removeEmployee (employee) {
            this.employees.splice(this.employees.indexOf(employee.value), 1)
        },

        onSelectAll () {
            const values = []
            if (this.employees.length !== this.employeeOptions.length) {
                this.employeeOptions.forEach(emp => {
                    values.push(emp.value)
                })
            }

            this.$set(this, 'employees', values)
        }
    },

    mounted () {
        this.$store.dispatch('setLoading', true)
        this.getEmployees()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        'monthPick' () {
            this.monthFormatted = this.monthFormat(this.monthPick)
        },

        async branchId (v) {
            this.$store.dispatch('setLoading', true)
            this.getEmployees(v)
            this.employees = []
            this.$store.dispatch('setLoading', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.space-between {
    display: flex;
    justify-content: space-between;
}
::v-deep .emp-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
::v-deep .v-list-item::before {
    opacity: 0 !important;
}
::v-deep .v-list-item__content {
    padding: 6px 0px;
    .v-input--selection-controls {
        margin-top: -2px !important;

        input {
            visibility: hidden;
        }
    }

    .v-list-item__title {
        color: #131410 !important;
    }
}
</style>
